export const VISIBLE_OPTIONS_TRUE = 'visible';
export const VISIBLE_OPTIONS_FALSE = 'hidden';
export const VISIBLE_OPTIONS = [true, 'true', VISIBLE_OPTIONS_TRUE];

export const READONLY_OPTIONS_TRUE = 'readonly';
export const READONLY_OPTIONS = [true, 'true', READONLY_OPTIONS_TRUE];

export function ordered(values) {
  return (typeof values === 'string' ? values.split(',') : values).sort().join(',');
}
